import Dialog, { DialogContainer, DialogTitle, DialogContent, DialogCheckBox, DialogBtnGroup } from 'components/Dialog';
import useModelClear from './hooks/useModelClear';

interface ModelClearDialogProps {
  onModelClear: () => void;
}

const ModelClearDialog = ({ onModelClear }: ModelClearDialogProps) => {
  const { checked, onCheckboxChange, onConfirm } = useModelClear({ onModelClear });
  return (
    <Dialog>
      <DialogContainer maxWidth={360}>
        <DialogTitle>모델 전체 삭제</DialogTitle>
        <DialogContent>{'연결된 모든 블록과 요소들이 삭제돼요\n정말 삭제하시겠어요?'}</DialogContent>
        <DialogCheckBox checked={checked} onChange={onCheckboxChange} />
        <DialogBtnGroup cancelText="취소" confirmText="삭제하기" onConfirm={onConfirm} />
      </DialogContainer>
    </Dialog>
  );
};

export default ModelClearDialog;
